import { useEffect, useState } from "react";

export function localMinute(timeZone: string, now = new Date()): string {
  const parts = new Intl.DateTimeFormat("sv-SE", { timeZone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(now);
  const value = (type: string) => parts.find(p => p.type === type)?.value ?? "";
  return `${value("year")}-${value("month")}-${value("day")}T${value("hour")}:${value("minute")}`;
}

/** Auch beim Wiederaufwachen sofort aktualisieren. Keine Gerätezeitzone für Familienzeiten verwenden. */
export function useFamilyNow(timeZone: string): string {
  const [now, setNow] = useState(() => localMinute(timeZone));
  useEffect(() => {
    const refresh = () => setNow(localMinute(timeZone));
    const timer = window.setInterval(refresh, 30_000);
    refresh();
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => { window.clearInterval(timer); window.removeEventListener("focus", refresh); document.removeEventListener("visibilitychange", refresh); };
  }, [timeZone]);
  return now;
}
